import React, { useState } from 'react';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { useQuery } from '@apollo/client';
import { GET_ALERT_SEVERITY_LIST } from '@nile/banyan/src/Graphql/Query/policy';
import { RMMClient } from '@nile/graphql';

import SeverityBlock from '@nile/rmm/src/modules/common/styles/severity.tsx';

const SeverityCell = (props) => {
  const { cell } = props;

  let data = cell.row.original;

  const { loading, data: severityData, error } = useQuery(
    GET_ALERT_SEVERITY_LIST,
    {
      client: RMMClient,
      variables: {}
    }
  );
  if (loading) return <div>loading...</div>;
  if (error) return <div>An error occurred...</div>;
  const colors = {};
  severityData?.getAlertSeverityTypes?.forEach((el) => {
    colors[el.name] = el.colorCode;
  });

  return cell.value ? (
    <SeverityBlock background={colors[data.severity] || '#B1B1B1'}>
      {cell.value}
    </SeverityBlock>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
};

export default SeverityCell;
